export default "__VITE_ASSET__CiN2uU64__"